import {Testimonial} from '@primer/react-brand/esm'
import type {Document} from '@contentful/rich-text-types'
import {renderWithoutParagraphs} from '../../utils'
import {resolveTestimonialLogo} from './resolve-testimonial-logo'
import type {TestimonialLogo} from './resolve-testimonial-logo'

export type FlexSuiteTestimonialQuoteProps = {
  quote?: Document
  name?: string
  title?: string
  link?: {href: string; text: string}
  logo?: TestimonialLogo
}

export function FlexSuiteTestimonialQuote({quote, name, title, link, logo}: FlexSuiteTestimonialQuoteProps) {
  if (!quote) return null

  const resolvedLogo = resolveTestimonialLogo(logo)

  return (
    <Testimonial variant="expressive" size="large">
      <Testimonial.Quote>{renderWithoutParagraphs(quote)}</Testimonial.Quote>
      {link && <Testimonial.Link href={link.href}>{link.text}</Testimonial.Link>}
      {resolvedLogo && (
        <Testimonial.Logo>
          <img
            src={resolvedLogo.url}
            alt={resolvedLogo.alt}
            style={{maxWidth: 120, maxHeight: 40, width: 'auto', height: 'auto'}}
          />
        </Testimonial.Logo>
      )}
      {name && <Testimonial.Name position={title}>{name}</Testimonial.Name>}
    </Testimonial>
  )
}
